import { render, staticRenderFns } from "./LinkAddNew.vue?vue&type=template&id=7fbcca22"
import script from "./LinkAddNew.vue?vue&type=script&lang=js"
export * from "./LinkAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports